import { useCallback } from 'react';
import { AText, Box, Button, InfoMessage } from '@alf/uikit';
import { PersonalOfficeWrapper } from '@namespace/account';
import { useGeneralRoutes } from '@namespace/cms';
import { useI18n } from '@namespace/i18n';
import { Image } from '@namespace/icons2';
import { useHistory } from '@namespace/router';

import styles from './index.module.css';

const VerificationFailure = () => {
  const { t } = useI18n();
  const { push } = useHistory();

  const { profileDocuments } = useGeneralRoutes();

  const onSubmit = useCallback(() => {
    push(profileDocuments);
  }, [push, profileDocuments]);

  return (
    <Box justify="center" component={PersonalOfficeWrapper}>
      <Box align="center" direction="column">
        <Image name="general/error" className={styles.icon} alt="" />

        <InfoMessage>
          <AText
            component="p"
            align="center"
            breed="B"
            color="po_txt_color_1"
            size="m"
          >
            {t('personaloffice.documents.additionalInformation.error.info')}
          </AText>
        </InfoMessage>

        <Button onClick={onSubmit} className={styles.tryAgainButton} size="l">
          {t('personaloffice.documents.additionalInformation.error.tryagain')}
        </Button>
      </Box>
    </Box>
  );
};

export default VerificationFailure;
